export default __webpack_public_path__ + "static/media/checkmark-circle-icon.049d4553.svg";